import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
// language list
import { TranslationService } from './core/services/translation.service';
import { locale as chLang } from './core/vocabs/ch';
import { locale as deLang } from './core/vocabs/de';
import { locale as enLang } from './core/vocabs/en';
import { locale as esLang } from './core/vocabs/es';
import { locale as frLang } from './core/vocabs/fr';
import { locale as jpLang } from './core/vocabs/jp';
import { ThemeModeService } from './shared/services/theme-mode.service';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly translationService: TranslationService,
    private readonly modeService: ThemeModeService
  ) {
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();
  }
}
